import type {
  CmmdProjectTaskAssignmentSubject,
  CreateCmmdBoardTaskParams,
} from "@cmmd-forge/contracts";

export function createAssignmentSubject(
  value: string | null,
): CmmdProjectTaskAssignmentSubject | undefined {
  if (!value) return undefined;
  const [kind, rawId] = value.split(":");
  const id = Number(rawId);
  if (!Number.isInteger(id) || id <= 0) return undefined;
  return kind === "agent"
    ? { kind: "agent_member", agentMemberId: id }
    : { kind: "human_user", userId: id };
}

export function createTaskWithOptionalAssignment(
  create: (
    params: CreateCmmdBoardTaskParams,
    assignment?: CmmdProjectTaskAssignmentSubject,
  ) => Promise<boolean>,
  params: CreateCmmdBoardTaskParams,
  assignment: CmmdProjectTaskAssignmentSubject | undefined,
): Promise<boolean> {
  return assignment === undefined ? create(params) : create(params, assignment);
}
